import { render, staticRenderFns } from "./NewsMagazineList.vue?vue&type=template&id=09be454c&"
import script from "./NewsMagazineList.vue?vue&type=script&lang=js&"
export * from "./NewsMagazineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports